
export const photos = [
    {
        src: "/assets/images/photo-gallery/rkguo_photos-33.jpg",
        width: 1902,
        height: 2663
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-34.jpg",
        width: 2894,
        height: 2067
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-35.jpg",
        width: 2422,
        height: 1730
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-36.jpg",
        width: 2727,
        height: 1948
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-1.jpg",
        width: 1,
        height: 1
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-2.jpg",
        width: 3,
        height: 1
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-3.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-4.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-5.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-6.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-7.jpg",
        width: 2,
        height: 1
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-8.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-9.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-10.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-11.jpg",
        width: 10,
        height: 16
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-12.jpg",
        width: 10,
        height: 16
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-13.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-14.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-15.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-16.jpg",
        width: 10,
        height: 13
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-17.jpg",
        width: 10,
        height: 13
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-18.jpg",
        width: 10,
        height: 16
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-19.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-20.jpg",
        width: 10,
        height: 16
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-21.jpg",
        width: 16,
        height: 10
    },

    {
        src: "/assets/images/photo-gallery/rkguo_photos-22.jpg",
        width: 16,
        height: 9
    },

    {
        src: "/assets/images/photo-gallery/rkguo_photos-23.jpg",
        width: 10,
        height: 13
    },

    {
        src: "/assets/images/photo-gallery/rkguo_photos-24.jpg",
        width: 13,
        height: 10
    },

    {
        src: "/assets/images/photo-gallery/rkguo_photos-25.jpg",
        width: 46,
        height: 10
    },

    {
        src: "/assets/images/photo-gallery/rkguo_photos-26.jpg",
        width: 1,
        height: 1
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-27.jpg",
        width: 10,
        height: 13
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-28.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-29.jpg",
        width: 16,
        height: 9
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-30.jpg",
        width: 16,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-31.jpg",
        width: 15,
        height: 10
    },
    {
        src: "/assets/images/photo-gallery/rkguo_photos-32.jpg",
        width: 13,
        height: 10
    },
  ];
  